import { render, staticRenderFns } from "./StaffUserSelect.vue?vue&type=template&id=0d232520"
import script from "./StaffUserSelect.vue?vue&type=script&lang=js"
export * from "./StaffUserSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports